module.exports = function() {
  return new Worker("./" + "pug-transpiler.b4d5da14.worker.js");
};